import { constants } from "src/environments/constants";

export class ShareResultsInfo {
  title: string = "";
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  company: string = "";
  optInToMarketing: boolean = false;
  resultsPageUrl: string = "";

  constructor(firstName: string, lastName: string, email: string, company: string, optIn: boolean, resultsPageUrl: string) {
    this.title = constants.SHARE_RESULTS_MESSAGE_TITLE;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.company = company;
    this.optInToMarketing = optIn;
    this.resultsPageUrl = resultsPageUrl;
  }
}
